import http, { createApi } from '@core/fetch'

export default {
  getStoreTypeApi: body =>
    http('/p/wedding/index.php/Home/APIManagers/properties', { body }),

  intro: createApi('/p/wedding/Admin/APIMerchant/merchant_check_status'),

  mark_list: () =>
    http('/p/wedding/index.php/Mainadmin/APISubMerchant/mark_list'),

  panoList: createApi('/p/wedding/index.php/Admin/APIMerchantPano/allPanoList'),

  summaryExamples: () => http('/p/wedding/admin/APIMerchant/summaryExamples'),

  kind_list: () => http('/p/wedding/index.php/admin/APIMerchant/kind_list'),

  //酒店获取商圈列表
  getBusinessAreaApi: createApi('/hps/admin/hotelMerchant/index/businessArea'),

  //检测酒店商家名是否存在
  checkNameApi: createApi('/hps/admin/hotelMerchant/index/checkName')
}
